const resource = 'payment_methods'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  getServiceName: name => 'paymentMethodService',
})
